<script setup lang="ts">
defineProps<{
  type: 'success' | 'error' | 'warning'
}>()

const colorMap = { success: 'bg-success-200', error: 'bg-danger-200', warning: 'bg-warn-200' }
</script>

<template>
  <div
    role="alert"
    :data-test="`alert-${type}`"
    :data-type="type"
    class="p-3 text-center rounded-md"
    :class="colorMap[type]"
  >
    <slot></slot>
  </div>
</template>
